module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "reservationModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Reservation Details\n  ")]), _vm._v(" "), (_vm.reservation) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "ui eleven wide column"
  }, [_c('div', {
    staticClass: "ui top attached segment"
  }, [_c('h4', [_vm._v(_vm._s(_vm.reservation.contact.title) + " " + _vm._s(_vm.reservation.contact.firstName) + " " + _vm._s(_vm.reservation.contact.lastName))]), _vm._v(" "), _c('p', [(_vm.reservation.contact.company) ? _c('span', [_vm._v("Company: " + _vm._s(_vm.reservation.contact.company)), _c('br')]) : _vm._e(), _vm._v("\n            Email: " + _vm._s(_vm.reservation.contact.email)), _c('br'), _vm._v("\n            Telephone: " + _vm._s(_vm.reservation.contact.tel)), _c('br'), _vm._v("\n            Address: " + _vm._s(_vm.reservation.contact.address)), _c('br'), _vm._v("\n            City: " + _vm._s(_vm.reservation.contact.city) + ", " + _vm._s(_vm.reservation.contact.zip)), _c('br')]), _vm._v(" "), (_vm.reservation.contact.comments) ? _c('div', [_c('h5', [_vm._v("Comments")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.reservation.contact.comments))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic table"
  }, [_c('tbody', [_vm._l((_vm.reservation.bookings), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm.reservation.boat.name) + "\n            ")]), _vm._v(" "), _c('td', [(_vm.boat && _vm.boat.startsAtHalfHour) ? _c('span', [_vm._v("\n                " + _vm._s((parseInt(booking.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(booking.hour.split(' - ')[1]) - 1) + ':30') + " h\n              ")]) : _c('span', [_vm._v("\n                " + _vm._s(booking.hour) + " h\n              ")])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n              €" + _vm._s(booking.cost) + ".00\n            ")])])
  }), _vm._v(" "), _vm._l((_vm.reservation.services), function(service) {
    return _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n              " + _vm._s(service.title) + "\n              "), (service.priceType === 'perPerson' && service.people) ? _c('span', [_vm._v("x" + _vm._s(service.people))]) : _vm._e(), _vm._v(" "), (!service.billed) ? _c('span', [_vm._v("(not billed)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(!service.billed) ? _c('span', [_vm._v("€0.00")]) : (service.priceType === 'perPerson' && service.people) ? _c('span', [_vm._v("\n                €" + _vm._s(_vm.numeral(service.price * service.people).format('0,00.00')) + "\n              ")]) : _c('span', [_vm._v("\n                €" + _vm._s(_vm.numeral(service.price).format('0,00.00')) + "\n              ")])])])
  }), _vm._v(" "), (_vm.reservation.discount) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.reservation.discount.voucher))])]) : _vm._e(), _vm._v(" "), (_vm.reservation.discount && _vm.reservation.discount.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.reservation.discount.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.reservation.discount && _vm.reservation.discount.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.reservation.discount.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.paymentTotal))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Additional Services")]), _vm._v(" "), _c('table', {
    staticClass: "ui basic table"
  }, [_c('tbody', _vm._l((_vm.reservation.services), function(service) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(service.title) + "\n              ")]), _vm._v(" "), _c('td', [(service.priceType === 'perPerson') ? _c('div', {
      staticClass: "ui mini labeled input"
    }, [_c('div', {
      staticClass: "ui label"
    }, [_vm._v("\n                    P\n                  ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.people),
        expression: "service.people"
      }],
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (service.people)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.people = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui basic tiny button",
      on: {
        "click": function($event) {
          _vm.toggleBillStatus(service._id)
        }
      }
    }, [(service.billed) ? _c('span', [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Billed")]) : _c('span', [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Off Bill")])])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui dropdown"
    }, [_c('div', {
      staticClass: "text"
    }, [(!service.status || service.status === 'pending') ? _c('span', {
      staticClass: "pending service status"
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (service.status === 'inProgress') ? _c('span', {
      staticClass: "in-progress service status"
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (service.status === 'delivered') ? _c('span', {
      staticClass: "delivered service status"
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]) : _vm._e(), _vm._v(" "), (service.status === 'escalated') ? _c('span', {
      staticClass: "problem service status"
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu",
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'pending')
        }
      }
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'inProgress')
        }
      }
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'delivered')
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]), _vm._v(" "), _c('div', {
      staticClass: "ui divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'escalated')
        }
      }
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Wishes")]), _vm._v(" "), _c('table', {
    staticClass: "ui basic table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm.reservation.wishes || "no additional wishes") + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "collapsing"
  }, [(_vm.reservation.wishes) ? _c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.wishesStatus || _vm.reservation.wishesStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('table', {
    staticClass: "ui basic table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm.reservation.questions || "no additional questions") + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "collapsing"
  }, [(_vm.reservation.questions) ? _c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.questionsStatus || _vm.reservation.questionsStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui five wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("People:")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui input",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.people),
      expression: "people"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number",
      "placeholder": "Enter number"
    },
    domProps: {
      "value": (_vm.people)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.people = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid button",
    on: {
      "click": _vm.savePeople
    }
  }, [_c('i', {
    staticClass: "save icon"
  }), _vm._v(" Save")])]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui selection dropdown",
    staticStyle: {
      "width": "100%",
      "min-width": "0"
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(_vm.reservation.status) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.checkIn($event)
      }
    }
  }, [_vm._v("Checked In")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.checkOut($event)
      }
    }
  }, [_vm._v("Finished")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Payment:")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px"
    }
  }, [_vm._v("To Pay: €" + _vm._s(_vm.paymentTotal))]), _vm._v(" "), _c('div', {
    staticClass: "ui selection dropdown",
    staticStyle: {
      "width": "100%",
      "min-width": "0"
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [(_vm.reservation.payment.status === 'paid') ? _c('span', [_vm._v("Paid")]) : _vm._e(), _vm._v(" "), (_vm.reservation.payment.status === 'unpaid') ? _c('span', [_vm._v("Unpaid")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.paid($event)
      }
    }
  }, [_vm._v("Paid")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.unpaid($event)
      }
    }
  }, [_vm._v("Unpaid")])])])])])])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ecb18b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reservations/DetailsModal.vue
// module id = 733
// module chunks = 1